import { useState } from 'react';
import Title from 'src/components/common/Title';
import PropertyList from '../PropertyList';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/RootState';
import Loading from 'src/components/common/Loading/Loading';
import { getEntitiesRewards } from 'src/apis/programsAssignment';
import LocationForm, { initialValuesProps } from '../LocationForm';

const SearchByLocation = () => {
    const token = useSelector((state: RootState) => state.User.token);
    const [loadingList, setLoadingList] = useState(false);
    const [list, setList] = useState([]);
    const [error, setError] = useState('');

    const handleSearch = (data: initialValuesProps) => {
        setLoadingList(true);
        const values = `from_xml=${data.from_xml}&lead_count_min=${data.lead_min}&lead_count_max=${data.lead_max}&from_data=${data.from_data}&broker_type=${data.type_user}&direction_id=${data.direction_id}`;
        getEntitiesRewards({ token, values })
            .then((res) => {
                setList(res.reward_properties || []);
                setLoadingList(false);
                setError(!res?.reward_properties || res?.reward_properties?.length < 1 ? '* No hay propiedades' : '');
            })
            .catch((e) => {
                console.error('Error búsqueda por ubicación', e);
                setError('Error en la búsqueda, verifique los datos');
                setLoadingList(false);
            });
    };

    const resetValues = () => {
        setList([]);
        setError('');
    };

    return (
        <>
            <Title>Búsqueda por ubicación</Title>
            <LocationForm handleSearch={handleSearch} loadingList={loadingList} resetValues={resetValues} />
            {loadingList ? (
                <div style={{ height: '250px' }}>
                    <Loading height="80%" />
                </div>
            ) : (
                ''
            )}
            {list?.length > 0 && <PropertyList list={list} setList={setList} />}
            <Title>{error}</Title>
        </>
    );
};

export default SearchByLocation;
